import { Suspense, useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { useNavigate } from "react-router-dom";
import { ViewApplicationTaskListData } from "./data/ViewApplicationTaskList.data";
import { ViewApplicationTaskListConfig } from "./data/ViewApplicationTaskListConfig";
import { encryptAESID } from "../../utils/Encryption";
import { useLazyGetDropDownsForProductsAndServicesQuery, useSgbpandSGBSApplicationTaskListMutation } from "../../app/services/productAndService/productAndServiceApi";
import { setAllDropDownField } from "./Utils/setFieldParameter";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { getAuthProps } from "../../lib/authenticationLibrary";


const ViewApplicationTaskListTable = () => {
  let authData = getAuthProps();
  const navigate = useNavigate();
  const molGridRef = useRef();
  const ViewApplicationRef = useRef();
  const [formData, setFormData] = useState(ViewApplicationTaskListData);
  const [dataSource, setDataSource] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    endPage: 100,
    CompanyUENNumber: "",
    SubmittedFrom: null,
    SubmittedTo: null,
    totalCount: 0,
    Channel: null,
    CategoryL1: null,
    CategoryL2: null,
    CategoryL3: null,

  });

  const [getSgbpandSGBSApplicationTaskList, { isSuccess, isLoading, data: taskListResponse }] = useSgbpandSGBSApplicationTaskListMutation();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();

  const handleViewClick = (data) => {
    let encryptedId = encryptAESID(data?.sgbpProductInformationId);
    let url = "";
    if (data?.status === "Pending Review") {
      url = data?.type === "Service" ? `/PeerReviewerServiceEvaluationApproval/${encryptedId}` : `/PeerReviewerEvaluationApproval/${encryptedId}`;
    } else if (data?.status === "Approval") {
      url = data?.type === "Service" ? `/FinalApproverForService/${encryptedId}` :`/finalApprover/${encryptedId}`;
    }
    else if (data?.status === "Evaluation" && data?.isBeenProcessed === true) {
      url = `/CertificateGroupingRequest/${encryptedId}`;
    }
    else if (data?.status === "Evaluation" || (data?.isSelfEvalutionRequirementClarificationPending == true || data?.isPendingSelfEvaluatioon)) {

      url = data?.type === "Service" ? `/CaseOfficerServiceEvaluation/${encryptedId}`:`/caseOfficerEvaluation/${encryptedId}`;
    }
    else if (data?.type === "Service") {
      url = `/ViewSGBSApplicationForm/${encryptedId}`;
    } else {
      url = `/viewSGBPApplicationForm/${encryptedId}`;
    }

    navigate(url);
  }

  const actionHandler = {
    "UPDATE": handleViewClick,
  }

  const handleSearch = () => {
    if (!ViewApplicationRef.current) {
      return;
    }
    const taskListFormData = ViewApplicationRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 10,
      endPage: 100,
      CompanyUENNumber: taskListFormData?.companyNameOrUen || "",
      SubmittedFrom: taskListFormData?.submittedFrom || null,
      SubmittedTo: taskListFormData?.submittedTo || null,
      Channel: taskListFormData?.channel?.value,
      CategoryL1: taskListFormData?.categoryL1?.value || taskListFormData?.categoryL1,
      CategoryL2: taskListFormData?.categoryL2?.value || taskListFormData?.categoryL2,
      CategoryL3: taskListFormData?.categoryL3?.value || taskListFormData?.categoryL3,
      StatusId: taskListFormData?.statusId?.value || taskListFormData?.statusId,
    };
    setPaginationRequest(updatedPaginationRequest);
    getSgbpandSGBSApplicationTaskList(updatedPaginationRequest);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getSgbpandSGBSApplicationTaskList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      submittedFrom: null,
      submittedTo: null,
      channel: null,
      categoryL1: null,
      categoryL2: null,
      categoryL3: null,
      companyNameOrUen: "",
      statusId: null
    };

    const request = {
      ...paginationRequest,
      CompanyUENNumber: "",
      totalCount: 0,
      SubmittedFrom: null,
      SubmittedTo: null,
      totalCount: 0,
      Channel: null,
      CategoryL1: null,
      CategoryL2: null,
      CategoryL3: null,
      StatusId: null
    };

    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getSgbpandSGBSApplicationTaskList(request);
    setFormData(updatedFormData);
  };

  function isButtonEnabled(item, adminUserId, adminRoleId) {
    if (item.status === "Pending Review") {
      return item.peerReviewerId === adminUserId;
    }
    if (item.status === "Approval") {
      return item.approverId === adminUserId;
    }
    if (adminRoleId === 9) {
      return false;
    }
    return true;
  }

  useEffect(() => {
    productsAndServicesDropdown()
    getSgbpandSGBSApplicationTaskList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!isLoading && isSuccess && taskListResponse) {
      setPaginationRequest(prev => ({ ...prev, totalCount: taskListResponse?.totalCount }));
      let taskList = taskListResponse?.itemList?.map((item) => {
        const canView = isButtonEnabled(item, authData?.adminUserId, authData?.roleId);
        return {
          ...item,
          subCategoryL2Name: item.subCategoryL2Name || "-",
          typeL3Name: item.typeL3Name || "-",
          assigned: item?.approverName != "" || item?.peerReviewerName != "" ? `${item?.peerReviewerName}/${item?.approverName}` : authData?.roleId === 9
            ? "-" : authData?.name,
          // assigned:item?.peerReviewerId === authData?.roleId ||item?.approverId  === authData?.roleId? `${item?.peerReviewerName}/${item?.approverName}`: authData?.name,
          isPeerReviewer: !canView,
        }
      })
      setDataSource(taskList);
    }
  }, [isLoading, isSuccess, taskListResponse]);
  // Approval and  Approved Pending Review
  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setAllDropDownField(productsAndServicesDropDownsData);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData]);

  return (
    <Suspense fallback={<DataLoader />}>
      <div className="corporate-member-list">
        <div className="member-list-filter row">
          <div className="row status-input col-9">
            {
              productsAndServicesDropDownsData && dataSource &&
              (
                <FormCreator ref={ViewApplicationRef} {...formData} />
              )
            }
          </div>
          <div className="col-3 right-side-btn">
            <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn btn-secondary mb-2"
              onClick={handleClearClick}
            />
            <Buttons
              buttonText="Search"
              buttonTypeClassName="success-btn"
              onClick={handleSearch}
            />
          </div>
        </div>

        <div className="member-list">
          <MolGrid
            ref={molGridRef}
            configuration={ViewApplicationTaskListConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    </Suspense>
  );
};

export default ViewApplicationTaskListTable;
